export default __webpack_public_path__ + "static/media/867.31ccd17d.png";